import { createContext, useContext, useEffect, useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "safestart.theme";
const ThemeContext = createContext(null);

const initial = () => localStorage.getItem(KEY) || "light";
document.documentElement.classList.toggle("dark", initial() === "dark");

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(initial);
  useEffect(() => {
    document.documentElement.classList.toggle("dark", theme === "dark");
    localStorage.setItem(KEY, theme);
  }, [theme]);
  const toggle = () => setTheme((t) => (t === "dark" ? "light" : "dark"));
  return <ThemeContext.Provider value={{ theme, toggle }}>{children}</ThemeContext.Provider>;
};

export const useTheme = () => useContext(ThemeContext);

export const ThemeToggle = ({ className = "", withLabel, testId = "theme-toggle" }) => {
  const { theme, toggle } = useTheme();
  const dark = theme === "dark";
  const Icon = dark ? Sun : Moon;
  const label = dark ? "Passer en mode clair" : "Passer en mode sombre";
  return (
    <button type="button" data-testid={testId} onClick={toggle} aria-label={label} title={label} className={className}>
      <Icon className="h-4 w-4" />
      {withLabel && <span>{dark ? "Mode clair" : "Mode sombre"}</span>}
    </button>
  );
};
